import React, { useEffect, useState } from 'react'
import { hapticTick, hapticSuccess } from '../../../../../_utils/haptics'
import { useScrollLock } from '../../../../../_utils/useScrollLock'
import { siteColour } from '../../../../../_services/sites.service'
import { CloseIcon } from '../../social/components/icons'
import { copyToLocations } from '../data/campaignStore'
import '../../plans/Plans.css'
import '../Campaigns.css'

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`

// A sheet in the builder's style
export const Sheet = ({ title, kind, onClose, children, foot }) => {
  useScrollLock(true)
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose() } }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [onClose])
  return (
    <div className="mkp-backdrop" onPointerDown={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="mkp-sheet" role="dialog" aria-modal="true" aria-label={title}>
        <header className="mkp-sheet-head">
          <div className="mkp-sheet-title">
            {kind && <span className="mkp-kind">{kind}</span>}
            <h2>{title}</h2>
          </div>
          <button type="button" className="mkp-icon-btn" onClick={onClose} aria-label="Close"><CloseIcon /></button>
        </header>
        <div className="mkp-body">{children}</div>
        {foot && <div className="mkp-foot">{foot}</div>}
      </div>
    </div>
  )
}

// Copy to other locations: a draft at each, approved there with that
// location's clients, consent and credits
export const CopySheet = ({ campaign, sites, active, onDone, onClose }) => {
  const targets = sites.filter(s => String(s.salonId) !== String(active && active.salonId))
  const [picked, setPicked] = useState(() => targets.map(s => String(s.salonId)))
  const toggle = (id) => { hapticTick(); setPicked(p => (p.includes(id) ? p.filter(x => x !== id) : [...p, id])) }
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  // Made by the server at each location, so its staff see the draft there
  const go = async () => {
    const chosen = targets.filter(s => picked.includes(String(s.salonId)))
    setBusy(true); setError('')
    try {
      await copyToLocations(campaign, chosen)
      hapticSuccess()
      onDone(chosen)
    } catch (e) {
      setError((e && e.message) || 'The copies weren’t made. Try again.')
    } finally {
      setBusy(false)
    }
  }
  return (
    <Sheet
      title="Copy to other locations"
      kind={campaign.name}
      onClose={onClose}
      foot={(
        <div className="mkp-foot-actions">
          <button type="button" className="mkp-ghost" onClick={onClose}>Cancel</button>
          <button type="button" className="mkp-primary" disabled={!picked.length || busy} onClick={go}>{busy ? 'Copying…' : picked.length ? `Make ${plural(picked.length, 'draft', 'drafts')}` : 'Pick a location'}</button>
        </div>
      )}
    >
      <p className="mkp-why is-lead">Each location gets its own draft of this campaign. When it’s approved there, it goes to that location’s clients, uses its message balance and links to its booking page.</p>
      <div className="cmg-sites">
        {targets.map((s) => {
          const id = String(s.salonId)
          return (
            <label key={id} className={`cmg-site${picked.includes(id) ? ' is-on' : ''}`}>
              <input type="checkbox" checked={picked.includes(id)} onChange={() => toggle(id)} />
              <i style={{ background: siteColour(id) }} aria-hidden />
              <span>{s.salonName}</span>
            </label>
          )
        })}
      </div>
      <p className="mkp-note">Free times on posts come from this location’s diary, so they’re marked to check at each one.</p>
      {error && <p className="mkp-note is-stop" role="alert">{error}</p>}
    </Sheet>
  )
}

